import React from "react";

import styles from "./FormNotice.module.scss";

export type FormNoticeProps = {
  message: string;
};

export const FormNotice: React.FC<FormNoticeProps> = ({ message }) => {
  return (
    <div className={styles.notice}>
      <i className="fa fa-exclamation-triangle" />
      <span>{message}</span>
    </div>
  );
};
